<script>
	// From Lucide
	import { ChevronsDown } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ChevronsDown class={iconClass} />
